import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import IngredientFormItem from './IngredientFormItem.js';
import ErrorSuccessAlerts from './ErrorSuccessAlerts.js';
import RecipeFormButtons from './RecipeFormButtons.js';

const RecipeForm = ({
  recipeData,
  setRecipeData,
  amountErrors,
  handleIngredientChange,
  handleAmountChange,
  addIngredient,
  removeIngredient,
  handleSubmit,
  navigate,
  isEditMode,
  error,
  success,
  isMobile,
  inventory
}) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {isEditMode ? 'Edit Recipe' : 'Review and Edit Recipe'}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Recipe Name"
            value={recipeData.name}
            onChange={(e) =>
              setRecipeData({ ...recipeData, name: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="Description"
            value={recipeData.description}
            onChange={(e) =>
              setRecipeData({ ...recipeData, description: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Ingredients
          </Typography>
          {recipeData.ingredients.map((ingredient, index) => (
            <IngredientFormItem
              key={index}
              ingredient={ingredient}
              index={index}
              inventory={inventory}
              amountError={amountErrors[index]}
              onRemove={removeIngredient}
              onChange={handleIngredientChange}
              onAmountChange={handleAmountChange}
              canRemove={recipeData.ingredients.length > 1}
              isMobile={isMobile}
            />
          ))}
          <Button 
            variant="outlined" 
            startIcon={<AddIcon />} 
            onClick={addIngredient} 
            sx={{ mt: 1 }}
          >
            Add Ingredient
          </Button>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Instructions"
            value={recipeData.instructions}
            onChange={(e) =>
              setRecipeData({ ...recipeData, instructions: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Garnish"
            value={recipeData.garnish}
            onChange={(e) =>
              setRecipeData({ ...recipeData, garnish: e.target.value })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Glass"
            value={recipeData.glass}
            onChange={(e) =>
              setRecipeData({ ...recipeData, glass: e.target.value })
            }
          />
        </Grid>
      </Grid>

      <ErrorSuccessAlerts error={error} success={success} />

      <RecipeFormButtons
        isEditMode={isEditMode}
        onCancel={() => navigate('/recipes/my-recipes')}
        onSubmit={handleSubmit}
        disabled={!recipeData.name.trim()}
      />
    </Box>
  );
};

export default RecipeForm; 